import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { crmAttachmentPath, safeContentUrl } from './content';
import { loadMarkdownFile } from './files';
import styles from './style.module.less';

function ContentImage({ src, alt }: { src?: string; alt?: string }) {
  const [resolved, setResolved] = useState('');
  useEffect(() => {
    let active = true,
      objectUrl = '';
    setResolved('');
    if (src && safeContentUrl(src)) {
      void loadMarkdownFile(src)
        .then((url) => {
          objectUrl = url.startsWith('blob:') ? url : '';
          if (active) setResolved(url);
          else if (objectUrl) URL.revokeObjectURL(objectUrl);
        })
        .catch(() => {
          if (active) setResolved('');
        });
    }
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);
  return resolved ? (
    <img src={resolved} alt={alt || ''} />
  ) : (
    <span>{alt || '图片暂不可用'}</span>
  );
}

export function MarkdownView({
  content = '',
  contentFormat,
}: {
  content?: string;
  contentFormat?: string;
}) {
  if (contentFormat !== 'markdown')
    return <div className={styles.plain}>{content}</div>;
  return (
    <div className={styles.view}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        urlTransform={safeContentUrl}
        components={{
          img: ({ src, alt }) => (
            <ContentImage
              src={typeof src === 'string' ? src : undefined}
              alt={alt}
            />
          ),
          a: ({ href, children }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={
                crmAttachmentPath(href)
                  ? (event) => {
                      event.preventDefault();
                      void loadMarkdownFile(href!)
                        .then((url) => {
                          const anchor = document.createElement('a');
                          anchor.href = url;
                          anchor.download =
                            typeof children === 'string' ? children : '附件';
                          anchor.click();
                          setTimeout(() => URL.revokeObjectURL(url), 10000);
                        })
                        .catch(() => message.error('附件加载失败，请重试'));
                    }
                  : undefined
              }
            >
              {children}
            </a>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
